import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './authentication/login/login.component';
import { QrCredentialComponent } from './authentication/qr-credential/qr-credential.component';
import { BuscarComponent } from './pages/buscar/buscar.component';
import { ColaenvioComponent } from './pages/colaenvio/colaenvio.component';
import { ComprasPreparacionComponent } from './pages/compras-preparacion/compras-preparacion.component';
import { InfoRetiraComponent } from './pages/info-retira/info-retira.component';
import { InicioComponent } from './pages/inicio/inicio.component';
import { InstruccionesfotoComponent } from './modal/instruccionesfoto/instruccionesfoto.component';
import { OpcionesComponent } from './pages/opciones/opciones.component';
import { PickerManualBultosPrepComponent } from './pages/picker-manual-bultos-prep/picker-manual-bultos-prep.component';
import { PickerManualBultosComponent } from './pages/opciones/picker-manual/picker-manual-bultos/picker-manual-bultos.component';
import { PickerManualPrepComponent } from './pages/picker-manual-prep/picker-manual-prep.component';
import { PickerManualComponent } from './pages/opciones/picker-manual/picker-manual.component';
import { PickerComponent } from './pages/picker/picker.component';
import { PuertasComponent } from './pages/puertas/puertas.component';
import { ReagendarComponent } from './pages/opciones/reagendar/reagendar.component';
import { RechazobultoComponent } from './pages/rechazobulto/rechazobulto.component';
import { ResultadoComponent } from './pages/resultado/resultado.component';
import { RunnersComponent } from './pages/runners/runners.component';
import { RutRunnerComponent } from './pages/rut-runner/rut-runner.component';
import { ScannerComponent } from './template/scanner/scanner.component';
import { OpcionesEntregaComponent } from './pages/opciones/opciones-entrega/opciones-entrega.component';
import { RecepcionBtComponent } from './pages/recepcion-bt/recepcion-bt.component';
import { ComentarioComponent } from './pages/opciones/comentario/comentario.component';
import { BineoComponent } from './pages/bineo/bineo.component';
import { AuthGuard } from './guards/auth.guard';


const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    pathMatch: 'full',
  },
  {
    path: 'recepcion-bt',
    component: RecepcionBtComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'opciones',
    component: OpcionesComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'opciones-entrega',
    component: OpcionesEntregaComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'comentarios',
    component: ComentarioComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'inicio',
    component: InicioComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'buscar',
    component: BuscarComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'colaenvio',
    component: ColaenvioComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'info-retira',
    component: InfoRetiraComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'instrucciones-foto',
    component: InstruccionesfotoComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'picker-manual',
    component: PickerManualComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'picker-manual-bultos',
    component: PickerManualBultosComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'compras-preparacion',
    component: ComprasPreparacionComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'picker',
    component: PickerComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'picker-manual-prep',
    component: PickerManualPrepComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'picker-manual-bultos-prep',
    component: PickerManualBultosPrepComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'rechazobulto',
    component: RechazobultoComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'puertas',
    component: PuertasComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'reagendar',
    component: ReagendarComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'resultado',
    component: ResultadoComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'runners',
    component: RunnersComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'rut-runner',
    component: RutRunnerComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'scanqr',
    component: ScannerComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'bineo',
    component: BineoComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'qr-credential/:codigo_local',
    component: QrCredentialComponent,
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'login'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
